var _a;
import { __decorate, __metadata } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { RouterService } from '@cores/services/vue-router-service';
import { SPACE_LABEL_ALL } from '../constants';
let SpaceLabelServiceImpl = class SpaceLabelServiceImpl {
    get _currentRoute() {
        return this._routerService.currentRoute;
    }
    getSpaceLabel() {
        const _label = this._currentRoute.query.label;
        const label = Array.isArray(_label) ? _label[0] : _label;
        return label === SPACE_LABEL_ALL ? '' : label;
    }
    resetSpaceLabel() {
        const _label = this._currentRoute.query.label;
        this.setSpaceLabel(_label === '' ? 'all' : '');
    }
    setSpaceLabel(label) {
        this._routerService.push({
            query: { ...this._currentRoute.query, label },
        });
    }
};
__decorate([
    inject(RouterService),
    __metadata("design:type", typeof (_a = typeof RouterService !== "undefined" && RouterService) === "function" ? _a : Object)
], SpaceLabelServiceImpl.prototype, "_routerService", void 0);
SpaceLabelServiceImpl = __decorate([
    injectable()
], SpaceLabelServiceImpl);
export { SpaceLabelServiceImpl };
